import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, createSlots as _createSlots } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_app_page = _resolveComponent("app-page")!

  return (_openBlock(), _createBlock(_component_app_page, { fheader: { showCollapse: true } }, {
    fheader: _withCtx(({ collapse }) => [
      _createVNode(_component_el_form, {
        size: "default",
        ref: "queryForm",
        "label-width": "120px",
        model: _ctx.params,
        class: "min-width-460",
        onKeyup: _cache[7] || (_cache[7] = _withKeys(($event: any) => (_ctx.handleSearch()), ["enter"]))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { label: "是否成功" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                clearable: "",
                placeholder: "选择状态",
                modelValue: _ctx.params.successful,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.successful) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.SUCCESSFUL_LIST, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: index,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "响应CODE" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                placeholder: "请输入响应CODE",
                modelValue: _ctx.params.code,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.params.code) = $event)),
                clearable: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          collapse
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: "请求参数"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    placeholder: "请输入请求参数",
                    modelValue: _ctx.params.requestParams,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.params.requestParams) = $event)),
                    clearable: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, { label: "请求时间" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.params.createdTime,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.params.createdTime) = $event)),
                type: "datetimerange",
                "range-separator": "至",
                "start-placeholder": "开始时间",
                "end-placeholder": "结束时间"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            "label-width": "0",
            class: "margin-left-10"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "default",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleSearch())),
                onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.handleSearch()), ["enter"]))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 查询 ")
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                size: "default",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleReset()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 重置 ")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 2
      }, 1032, ["model"])
    ]),
    main: _withCtx(({
        height
      }) => [
      (_openBlock(), _createBlock(_component_el_table, {
        height: height,
        key: height,
        data: _ctx.tableData,
        border: "",
        tableLayout: "fixed"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "logId",
            label: "日志ID",
            align: "center",
            "min-width": "150"
          }, _createSlots({ _: 2 }, [
            (_ctx.$has(_ctx.permissionConfig.SSOXQ))
              ? {
                  name: "default",
                  fn: _withCtx(({row}) => [
                    _createVNode(_component_router_link, {
                      to: {
                name: 'SsoCenterSsoManageDetail',
                params: {
                  id: row.logId,
                },
              },
                      target: "_self"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.logId), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1024),
          _createVNode(_component_el_table_column, {
            prop: "successful",
            label: "是否成功",
            align: "center"
          }, {
            default: _withCtx(({row}) => [
              _createTextVNode(_toDisplayString(row.successful?"成功":"失败"), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "requestUrl",
            label: "请求地址",
            "min-width": "420",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "requestTime",
            label: "请求时间",
            align: "center",
            "min-width": "150"
          }, {
            default: _withCtx(({row}) => [
              _createTextVNode(_toDisplayString(_ctx.$filters.formatTime(row.requestTime)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "responseTime",
            label: "响应时间",
            align: "center",
            "min-width": "150"
          }, {
            default: _withCtx(({row}) => [
              _createTextVNode(_toDisplayString(_ctx.$filters.formatTime(row.responseTime)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "executeTime",
            label: "执行时间(ms)",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "code",
            label: "响应CODE",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "message",
            label: "响应消息",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "creatorName",
            label: "用户名",
            align: "center"
          })
        ]),
        _: 2
      }, 1032, ["height", "data"]))
    ]),
    ffooter: _withCtx(() => [
      _createVNode(_component_el_row, {
        style: {"width":"100%"},
        type: "flex",
        justify: "end"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_pagination, {
            total: _ctx.tableTotal,
            "current-page": _ctx.params.pageNum,
            size: _ctx.params.pageSize,
            onSizeChange: _ctx.handleSizeChange,
            onCurrentChange: _ctx.handleCurrentChange
          }, null, 8, ["total", "current-page", "size", "onSizeChange", "onCurrentChange"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}